<template>
  <div class="table">
    <table>
      <thead>
        <tr>
          <th class="checkbox tableCheckbox">
            <input type="checkbox" id="checkAll" v-model="checkedAll" @change="onCheckedAll($event)">
            <label for="checkAll"><span class="blind">check all</span></label>
          </th>
          <th>{{locale.title}}</th>
          <th class="center">{{locale.table_createat}}</th>
          <th class="center">{{locale.table_updateat}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="main" class="emphasis">
          <td class="checkbox tableCheckbox">
            <input type="checkbox" name="checkItem" :id="`check${main.menuId}`" :value="main.menuId" v-model="checkedItem" @change="onCheckedItem($event)">
            <label :for="`check${main.menuId}`"><span class="blind">check</span></label>
          </td>
          <td><router-link :to="{name: 'menuItem', params: {id: main.menuId}}" class="subject"><i>&#10070;</i> {{main.menuData.name}}</router-link></td>
          <td class="center date">{{date(main.menuData.created)}}</td>
          <td class="center date">{{date(main.menuData.updated)}}</td>
        </tr>
        <tr v-if="!list.length && !main" class="noData"><td colspan="4">{{locale.menu_list_nodata}}</td></tr>
        <tr v-else v-for="menu in list" :key="menu.menuId">
          <td class="checkbox tableCheckbox">
            <input type="checkbox" name="checkItem" :id="`check${menu.menuId}`" :value="menu.menuId" v-model="checkedItem" @change="onCheckedItem($event)">
            <label :for="`check${menu.menuId}`"><span class="blind">check</span></label>
          </td>
          <td><router-link :to="{name: 'menuItem', params: {id: menu.menuId}}" class="subject">{{menu.menuData.name}}</router-link></td>
          <td class="center date">{{date(menu.menuData.created)}}</td>
          <td class="center date">{{date(menu.menuData.updated)}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DATE from '@/common/date'

export default {
  name: 'MenuList',
  props: [
    'locale',
    'init',
    'main',
    'list'
  ],
  watch: {
    init (isInit) {
      if (isInit) {
        this.checkedItem = []
      }
    },
    checkedItem (ids) {
      this.$emit('checked', ids)
    }
  },
  data () {
    return {
      checkedItem: [],
      checkedAll: false
    }
  },
  methods: {
    date (date) {
      return DATE.toString(date)
    },
    onCheckedAll (e) {
      const checked = e.target.checked
      this.checkedAll = checked
      let allId = []
      if (checked) {
        this.list.forEach(x => {
          allId.push(x.menuId)
        })
        if (typeof (this.main) !== 'undefined') {
          allId.push(this.main.menuId)
        }
      }
      this.checkedItem = allId
    },
    onCheckedItem (e) {
      const checked = e.target.checked
      if (!checked) {
        this.checkedAll = false
      }
    }
  }
}
</script>
